function page(path) {
  return () =>
    import(/* webpackChunkName: '' */ `@/views/front/${path}`).then(
      (m) => m.default || m
    );
}

export default [
  {
    path: "/",
    name: "Home",
    component: page("home/Home.vue"),
    hidden: true,
    meta: {
      title: "Home",
      noCache: true,
    },
  },
  {
    path: "/privacy-policy",
    // path: "/",
    name: "PrivacyPolicy",
    component: page("privacyPolicy/PrivacyPolicy.vue"),
    hidden: true,
    meta: {
      title: "Privacy policy",
      noCache: true,
    },
  },
  {
    path: "/trade-condition",
    // path: "/",
    name: "TradeCondition",
    component: page("tradeCondition/TradeCondition.vue"),
    hidden: true,
    meta: {
      title: "Trade condition",
      noCache: true,
    },
  },
  {
    path: "/:id/discovery",
    name: "Discovery",
    component: page("discovery/Discovery.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Discovery",
      noCache: true,
    },
  },
  {
    path: "/:id/menu/:tableId",
    name: "Menu",
    component: page("discovery/Discovery.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Menu",
      noCache: true,
    },
  },
  {
    path: "/:id/checkout/:tableId",
    name: "CheckoutQuick",
    component: page("checkout/CheckoutQuick.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Checkout",
      noCache: true,
    },
  },
  {
    path: "/:id/checkout",
    name: "Checkout",
    component: page("checkout/Checkout.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Checkout",
      noCache: true,
    },
  },
  {
    path: "/:id/flatpay",
    name: "FlatPayPayment",
    component: page("checkout/FlatPayPayment.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Flatpay Payment",
      noCache: true,
    },
  },
  {
    path: "/:id/payment",
    name: "PaymentProgress",
    component: page("checkout/PaymentProgress.vue"),
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Payment Progress",
      noCache: true,
    },
  },
  {
    path: "/:id/thanks/:orderref",
    name: "Thanks",
    hidden: true,
    component: page("thanks/Thanks.vue"),
    props: (route) => ({ propOrderRef: route.params.orderref }),
    meta: {
      title: "Thanks",
      noCache: true,
    },
  },
  {
    path: "/:id/thanks/:tableId/:orderref",
    name: "ThanksQuick",
    hidden: true,
    component: page("thanks/QuickOrderThanks.vue"),
    props: (route) => ({ propOrderRef: route.params.orderref }),
    meta: {
      title: "Thanks",
      noCache: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    hidden: true,
    component: page("profile/Profile.vue"),
    meta: {
      title: "Profile",
      noCache: true,
    },
  },
  {
    path: "/password/reset",
    name: "ResetPassword",
    hidden: true,
    component: page("resetPassword/ResetPassword.vue"),
    meta: {
      title: "ResetPassword",
      noCache: true,
    },
  },
];
